<intl-telephone-input
  [preferredCountries]="[CountryISO.SaudiArabia, CountryISO.Egypt]"
  [enablePlaceholder]="true"
  [searchCountryFlag]="true"
  [separateDialCode]="false"
  [enableAutoCountrySelect]="true"
  [searchCountryField]="SearchCountryField.All"
  [phoneValidation]="true"
  [numberFormat]="PhoneNumberFormat.International"
  [selectFirstCountry]="false"
  [selectedCountryISO]="selectedCountryISO"
  [inputId]="'phone'"
  (onChange)="onInputChange($event)"
  [attr.autocomplete]="'off'"
  [attr.name]="'phone_no_autofill'"
  style="height: 50px;"
  #phoneInput>
</intl-telephone-input>

<!-- <intl-telephone-input [formControl]="control" [preferredCountries]="[CountryISO.SaudiArabia, CountryISO.Egypt]"
  [enablePlaceholder]="true" [searchCountryFlag]="true" [separateDialCode]="false" [enableAutoCountrySelect]="true"
  [searchCountryField]="SearchCountryField.All" [phoneValidation]="true"
  [numberFormat]="PhoneNumberFormat.International"  
   [inputId]="'phone'" (onChange)="onInputChange($event)"
   [attr.autocomplete]="'off'" 
  [attr.name]="'phone_no_autofill'" 
  style="height: 50px;" #phoneInput>
</intl-telephone-input> -->
<div class="errorBlock">
  <app-error [type]="type" [control]="control" [customStyle]="customErrorStyle"></app-error>
</div>

<!-- [numberFormat]="PhoneNumberFormat.International" -->
<!-- [numberFormat]="PhoneNumberFormat.E164" -->

